import { render, staticRenderFns } from "./OpeningLand.vue?vue&type=template&id=23419687"
import script from "./OpeningLand.vue?vue&type=script&lang=js"
export * from "./OpeningLand.vue?vue&type=script&lang=js"
import style0 from "./OpeningLand.vue?vue&type=style&index=0&id=23419687&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports